import { gql } from "~/__generated__"

gql(/* GraphQL */ `
  fragment CalendarPost on ContentPost {
    id
    title
    body
    status
    lockVersion
    editable
    authorName
    scheduledAt
    scheduledTimeZone
    postedAt
    linkedinUrl
  }
`)
export const OPERATIONS = gql(/* GraphQL */ `
  query MyOperations {
    operationsWorkspace {
      posts {
        ...CalendarPost
      }
      profile {
        id
        timeZone
        fridayTime
        postsPerWeek
        slackRemindersEnabled
        slackChannelId
      }
      slackConfigured
      reminders {
        id
        kind
        status
        message
        error
        sentAt
        createdAt
      }
      budget {
        fixedCents
        accountedCents
        capCents
        warning
        uncertainCount
        entries {
          id
          provider
          operation
          status
          reservedCents
          actualCents
          error
          createdAt
        }
      }
    }
  }
`)
export const CALENDAR_DETAIL = gql(/* GraphQL */ `
  query CalendarPostDetail($id: ID!) {
    editorialWorkspace {
      post(id: $id) {
        ...CalendarPost
      }
    }
    experienceProfile {
      id
      timeZone
      postsPerWeek
    }
  }
`)
export const SCHEDULE = gql(/* GraphQL */ `
  mutation SchedulePost($input: PostScheduleInput!) {
    postSchedule(input: $input) {
      post {
        ...CalendarPost
      }
    }
  }
`)
export const MARK_POSTED = gql(/* GraphQL */ `
  mutation MarkPostPublished($input: PostMarkPublishedInput!) {
    postMarkPublished(input: $input) {
      post {
        ...CalendarPost
      }
    }
  }
`)
export const RETRY_REMINDER = gql(/* GraphQL */ `
  mutation RetryReminder($input: ReminderRetryInput!) {
    reminderRetry(input: $input) {
      success
    }
  }
`)
